<template>
  <div class="container">
    <Header />
    <div class="content">
      <div class="purchase_list">
        <div class="purchase_title">购买记录</div>
        <el-table :data="tableData" border style="width: 100%;padding:0" class="tab">
          <el-table-column
            class="th"
            align="center"
            prop="orderNum"
            label="订单号"
            width="285"
            style="font-size:16px;"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="subjectName"
            label="科目"
            width="335"
          ></el-table-column>
          <el-table-column
            align="center"
            prop="time"
            label="购买时间"
            width="335"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import api from "../axios/interface";
export default {
  // 购买记录页面
  name: "PurchaseRecord",
  data() {
    return {
      tableData: []
    };
  },

  mounted() {
    this.getPurchaseRecordList()
  },

  methods: {
    getPurchaseRecordList() {
      let that = this;
      this.$axios.get(api.GetBuysRecord,{},{ hideMessage: true })
        .then(res => {
          this.tableData = res.result.data
        })
    }
  },

  components: {
    Header: Header,
    Footer: Footer
  }
};
</script>
<style scoped>
.header {
  background-color: #fff;
}
.content {
  width: 1056px;
  margin: 90px 50px 0 50px;
  height: 575px;
  text-align: center;
  border-radius: 20px;
  background: #fff;
  display: flex;
  flex-direction: column;
}

.purchase_title {
  width: 1000px;
  height: 37px;
  line-height: 37px;
  text-align: center;
  font-size: 32px;
  color: #4d4d4d;
  margin-top: 50px;
  margin-bottom: 40px;
}
.purchase_list {
  /* width: 1000px; */
  height: auto;
  margin: 0 50px 0 50px;
  padding-top: 30px;
}
</style>
<style lang="less">
.tab thead th > .cell {
  display: inline-block;
  box-sizing: border-box;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  color: #fff;
  vertical-align: middle;
  background-color: #0079fe;
}
.tab th {
  padding: 0 !important;
  height: 48px;
}
.tab tr {
  padding: 0 !important;
  height: 45px;
}
.tab tbody tr > .cell {
  display: inline-block;
  box-sizing: border-box;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  color: #fff;
  vertical-align: middle;
}
</style>
